import $ from 'jquery';
import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import { convertDateToDdMmYyyy } from '@/function/function.js';
import VoirResultat from '@/views/analyse/visualiser-resultat';

import EnteteBonEtFacture from '@/views/en-tete-bon-facture';
import EnteteA5 from '@/views/entete-a5';

import Vue from 'vue';
import VueHtml2pdf from 'vue-html2pdf'
Vue.use(VueHtml2pdf)

export default {
    name: 'examen-bio',
    components: {
        VueHtml2pdf, VoirResultat,
        EnteteBonEtFacture, EnteteA5
    },
    props: [
        "consultation_id", "activeRole", "is_printable"
    ],
    data () {
        return {
            vm_state: open_menu_state,   
            drp_menu_class: [],

            format_analyse: 'a5',       //  A5 (si prescriptions <= 6 ) ou A4 ( si prescription > 6)
            width_analyse: '559px',
            font_size: 'font-14',
            date_resultat: '',           //  Date d'enregistrement du résultat
            filename: '',

            ver: null,
            demandes: [],
            demande: null,              //  Demande analyse | fichier attaché
            verdict:[
                {
                    libelle: "Positif",
                    state: true
                },
                {
                    libelle: "Négatif",
                    state: false
                }
            ],

            bulletin_is_loading: true,
            bulletin_is_empty: false,
            edit_bulletin: {
                bulletin_id: 0,
                ref_bon: '',
                analyses: []
            }
        }
    },

    watch: {
        demande_analyses() {
            this.demandes = this.demande_analyses
        }
    },

    computed: {
        //Recuperation des demandes d'analyse (Charge dans le component parent)

        demande_analyses() {
            return this.$store.getters["demandesAnalysesHistorique"];
        },

        bulletin_analyse_historique() {
            return this.$store.getters["bulletin_analyse_historique"];
        },

        patient(){
            return this.$store.getters['patient'];
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        consultation(){
            return this.$store.getters["consultationPatientEnCours"];
        },

        /**
         * Calculer le prix total des analyses
         */
        total_prix_analyse() {
            let total = 0;
            if (this.demande_analyses) {
                if (this.demande_analyses.length > 0) {
                    this.demande_analyses.forEach(data => {
                        let prix_analyse = 0
                        prix_analyse = parseInt(data.analyse.prix)
                        total += prix_analyse;
                    })
                }
            }
            return total;
        }
    },
    mounted () {
        this.demandes = this.demande_analyses
        let t = this;

        $(document).bind("click", function(e) {
            let $clicked = $(e.target);
            if (!$clicked.parents().hasClass("drp-container")) {
                if(t.vm_state != 0) {
                    t.openMenu(t.vm_state, 'drp-menu', 'animate-zoomIn', 'animate-zoomOut')
                }
            }
        });

        for(let i = 0; i < this.demande_analyses.length; i++) {
            this.drp_menu_class[i] = 'drp_menu_pos'+this.demande_analyses[i].id;
        }

        this.date_resultat = convertDateToDdMmYyyy.convertDate(new Date());

        let tm = new Date()
        this.filename = 'Bulletin Analyse_'+this.patient.nom+' '+this.patient.prenoms+'_'+tm.getTime()

        this.refreshExamenBio()
    },
    methods: {
        refreshExamenBio() {
            this.bulletin_is_loading = true

            let data = {
                consultation_id: this.consultation_id,
                protocole_id: 0,
                est_encours: false
            }

            this.$store.dispatch('getBulletinAnalyses', data).then(() => {
                if (this.bulletin_analyse_historique.length > 0) {
                    this.bulletin_is_empty = false
                } else {
                    this.bulletin_is_empty = true
                }
                this.bulletin_is_loading = false
            })
        },

        /**
         * Rafraichir les examens bio
         */
        // refreshExamenBio() {
        //     this.$store.dispatch('getDemandeAnalyses', { id: this.consultation_id, enCours: false })
        // },

        updateValueAction(demande){
           this.$store.dispatch("updateTDR",{id:demande.id,data:demande,consultId: this.consultation_id}).then(
               () =>{
                   this.successTDRupdated()
               }
           )
        },

        selectAnalyseUpload(demande) {
            this.demande = demande
        },
        
        successTDRupdated: function(){
            this.$toasted.show('Le résultat de l\'analyse TDR a été mis à jour',{
              duration: 3000,
              action:[
               {
                 text:'X',
                 onClick:(e,toastObject)=>{
                   toastObject.goAway(0);
                 }
               }
             ],
             theme:'toasted-primary',
             type:'success',
             position:'top-center'
             
            })
        },


        /**
         * Open Menu Dropdown
         */
        async openMenu(state, selector, show_in, show_out) 
        {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
        * Close Menu Dropdown
        */
        async closeMenu(selector, show_in, show_out) 
        {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        async deleteDemandeAnalyse(id) {
            this.$store.dispatch('deleteDemandeAnalyse', id )
        },

        // /**
        //  * 
        //  * @param {*} route 
        // */
        routeTo(route) 
        {
            this.$router.push({ path: '/analyses/'+route })
        },

        formatNumbers(num) {
            return new Number(num).toLocaleString("fr-FR");
        },

        setPdfFormat() {
            console.log("LEN: ",this.demande_analyses.length)
            if (this.demande_analyses.length <= 6) {
                this.format_analyse = 'a5'
                this.width_analyse = '559px'
                this.font_size = 'font-14'
            } else if (this.demande_analyses.length <= 8) {
                this.format_analyse = 'a5'
                this.width_analyse = '559px'
                this.font_size = 'font-10'
            } else {
                this.format_analyse = 'a4'
                this.width_analyse = '800px'
                this.font_size = 'font-16'
            }

        },

        /**
         * Imprimer une demande d'analyse
         */
        async printDemandeAnalyse(b) {
            this.edit_bulletin = {
                bulletin_id: b.bulletin_id,
                ref_bon: b.ref_bon,
                user: b.user,
                analyses: b.analyses
            }

            await this.setPdfFormat()

            this.$refs.analyse_html2Pdf.generatePdf()
        },

        async beforeDownload({ html2pdf, options, pdfContent }) {
            await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
                // const totalPages = pdf.internal.getNumberOfPages()

                let foot_content = 'Généré(e) via l\'application Clinicaa';

                let la_medecin = 'Le Médecin';
                let lome_le = this.ville_le + this.date_resultat;
                // let total_a_payer = 'Total à payer: ' + this.total_prix_analyse;
                // let total_label = 'Total à payer';

                if (this.format_analyse == 'a5') {
                    // A PAYER
                    pdf.setTextColor(0)
                    pdf.setFontSize(14)
                    // pdf.text(total_a_payer, (3.6), (pdf.internal.pageSize.getHeight() - 1.5))

                    // LOME LE
                    pdf.setTextColor(150)
                    pdf.setFontSize(8)
                    pdf.text(lome_le, (0.5), (pdf.internal.pageSize.getHeight() - 1))

                    // LA CAISSE
                    pdf.setTextColor(150)
                    pdf.setFontSize(8)
                    pdf.text(la_medecin, (4.7), (pdf.internal.pageSize.getHeight() - 1))

                    // FOOTER
                    pdf.setTextColor(150)
                    pdf.setFontSize(6)
                    pdf.text(foot_content, (2.3), (pdf.internal.pageSize.getHeight() - 0.1))
                } else {
                    // LOME LE
                    pdf.setTextColor(150)
                    pdf.setFontSize(10)
                    pdf.text(lome_le, (0.5), (pdf.internal.pageSize.getHeight() - 1.4))

                    // LA CAISSE
                    pdf.setTextColor(150)
                    pdf.setFontSize(10)
                    pdf.text(la_medecin, (7), (pdf.internal.pageSize.getHeight() - 1.4))

                    // FOOTER
                    pdf.setTextColor(150)
                    pdf.setFontSize(6)
                    pdf.text(foot_content, (3.333858), (pdf.internal.pageSize.getHeight() - 0.3))
                }

            }).save()
        },

        onProgress(ev) {
            console.log(ev)
        },

        hasStartedGeneration() {

        },

        hasGenerated(ev) {
            console.log(ev)
        }
    }
}